import React from "react";
import './Surrounding.css'

const Surrounding = () => {
  return (
    <div>
      <div className="surrounding">
        <h3>SURROUNDINGS</h3>
        <video src="./HomePhotos/Surrounding/surrounding.mp4" controls></video>
      </div>
    </div>
  );
};

export default Surrounding;
